function LessonGroupTable() {
  return (
    <figure className='my-8'>
      <figcaption className='mb-2 text-center font-medium'>جدول شماره 1: پنج گروه درسی</figcaption>
      <table className='w-full table-auto border-collapse border border-zinc-400 text-sm'>
        <thead className='bg-zinc-300'>
          <tr>
            <th className='border border-zinc-400 p-1 text-center font-semibold xs:p-3'>
              گروه درسی
            </th>
            <th className='border border-zinc-400 p-1 text-center font-semibold xs:p-3'>درس‌ها</th>
          </tr>
        </thead>
        <tbody>
          <tr className='odd:bg-white even:bg-zinc-200'>
            <td className='border border-zinc-400 p-1 text-center font-semibold xs:p-3'>یک</td>
            <td className='border border-zinc-400 p-1 text-center xs:p-3'>جراحی عمومی - زنان</td>
          </tr>
          <tr className='odd:bg-white even:bg-zinc-200'>
            <td className='border border-zinc-400 p-1 text-center font-semibold xs:p-3'>دو</td>
            <td className='border border-zinc-400 p-1 text-center xs:p-3'>داخلی</td>
          </tr>
          <tr className='odd:bg-white even:bg-zinc-200'>
            <td className='border border-zinc-400 p-1 text-center font-semibold xs:p-3'>سه</td>
            <td className='border border-zinc-400 p-1 text-center xs:p-3'>کودکان - عفونی</td>
          </tr>
          <tr className='odd:bg-white even:bg-zinc-200'>
            <td className='border border-zinc-400 p-1 text-center font-semibold xs:p-3'>چهار</td>
            <td className='border border-zinc-400 p-1 text-center xs:p-3'>
              ارتوپدی - گوش و حلق بینی - اورولوژی - چشم - آمار و اپیدمیولوژی - رادیولوژی
            </td>
          </tr>
          <tr className='odd:bg-white even:bg-zinc-200'>
            <td className='border border-zinc-400 p-1 text-center font-semibold xs:p-3'>پنج</td>
            <td className='border border-zinc-400 p-1 text-center xs:p-3'>
              آسیب شناسی - پوست - فارماکولوژی - نورولوژی - روانپزشکی - اخلاق پزشکی
            </td>
          </tr>
        </tbody>
      </table>
    </figure>
  );
}

export default LessonGroupTable;
